import { createSelector } from 'reselect';

import { learningYearFinalPerformanceSelector } from './learningYearPerformanceSelector';

export const finalMarkUnfilteredYearsSelector = createSelector(
  [learningYearFinalPerformanceSelector],
  (finalPerformance) => finalPerformance.content.map((perfomance) => perfomance.year),
);
